import { Maybe } from '@graphql-tools/utils'
import classNames from 'classnames'
import { When } from 'react-if'
import { EyebrowMD } from '@/atoms/Text'

interface ContentRatingBadgeProps {
  contentRating?: Maybe<string>
  className?: string
}

export const ContentRatingBadge: React.FC<ContentRatingBadgeProps> = ({ contentRating, className }) => {
  const formattedRating = useFormattedRating({ contentRating })
  return (
    <When condition={formattedRating && formattedRating?.length > 0}>
      <EyebrowMD className={classNames('w-fit whitespace-nowrap rounded border px-1', className)}>
        {formattedRating}
      </EyebrowMD>
    </When>
  )
}

export const useFormattedRating = ({ contentRating }: { contentRating: Maybe<string> }) => {
  if (typeof contentRating === 'string') {
    return contentRating.toUpperCase().replace('_', '-')
  }
  return undefined
}
